import { useState } from 'react';
import { Button, Checkbox, Modal } from '@tencent/tea-component';
import { useTranslation } from 'react-i18next';
import { BOOL, SiStatus } from '@tencent/wemeet-websdk-next';
import { useAppSelector } from '@store/index';

import wemeetClient from '@utils/wemeetClient';
import { getSiStatus } from '@store/meeting/meeting.slice';
import './HostControlZoom.scss';
import { openToast } from '@component/toast';

export default function HostControlZoom({ isHost = false, isCoHost = false, isCreator = false }) {
  const { t } = useTranslation();
  const siStatus = useAppSelector(getSiStatus);

  const [muteModalVisible, setMuteModalVisible] = useState(false);
  const [muteSi, setMuteSi] = useState(false);
  const [allowUnmuteBySelf, setAllowUnmuteBySelf] = useState(false);

  const handleClickMuteAll = () => {
    setMuteModalVisible(true);
  };

  const handleClickUnmuteAll = () => {
    wemeetClient.hostCtrl.muteAllAudio(BOOL.false).then(() => {
      openToast(t('已请求全体成员开麦'));
    });
  };

  const handleMuteAll = () => {
    const ifMuteSi = muteSi ? BOOL.true : BOOL.false;
    const ifAllowUnmuteBySelf = allowUnmuteBySelf ? BOOL.true : BOOL.false;
    console.log('allowUnmuteBySelf', allowUnmuteBySelf);
    wemeetClient.hostCtrl.muteAllAudio(BOOL.true, ifMuteSi, ifAllowUnmuteBySelf).then(() => {
      setMuteModalVisible(false);
    });
  };

  const handleClickReclaimHost = () => {
    wemeetClient.hostCtrl.reclaimHost();
  };

  return (
    <div className={'host-control-zoom'}>
      {isHost || isCoHost ? (
        <Button type={'primary'} onClick={handleClickMuteAll}>
          {t('全体静音')}
        </Button>
      ) : null}
      {isHost || isCoHost ? <Button onClick={handleClickUnmuteAll}>{t('解除全体静音')}</Button> : null}
      {!isHost && isCreator ? <Button onClick={handleClickReclaimHost}>{t('收回主持人')}</Button> : null}

      <Modal
        className={'host-control-zoom__modal'}
        disableCloseIcon
        caption={<p className={'host-control-zoom__modal__title'}>{t('所有以及新加入成员将被静音')}</p>}
        visible={muteModalVisible}
        onClose={() => {
          setMuteModalVisible(false);
        }}
      >
        <Modal.Body>
          <div className="host-control-zoom__modal__content">
            <Checkbox
              value={allowUnmuteBySelf}
              onChange={(value) => {
                console.log('setAllowUnmuteBySelf', value);
                setAllowUnmuteBySelf(value);
              }}
            >
              {t('成员可以自己解除静音')}
            </Checkbox>
            {siStatus === SiStatus.STARTED ? (
              <Checkbox
                value={muteSi}
                onChange={(value) => {
                  setMuteSi(value);
                }}
              >
                {t('静音全部成员，包括同传译员')}
              </Checkbox>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setMuteModalVisible(false);
            }}
          >
            {t('取消')}
          </Button>
          <Button type={'primary'} onClick={handleMuteAll}>
            {t('全体静音')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
